import { ClipboardList, MapPin, PencilRuler, HardHat } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/landing/Reveal";
import { STEPS } from "@/data/content";

const iconMap = { ClipboardList, MapPin, PencilRuler, HardHat };

const HowItWorks = () => (
  <section id="process" className="py-24 md:py-32 bg-brand-grey/60" data-testid="how-it-works-section">
    <div className="max-shell mx-auto px-4 md:px-8 lg:px-12">
      <Reveal className="flex justify-center text-center">
        <SectionHeading
          eyebrow="How It Works"
          title="From Consultation To Clean Energy"
          subtitle="A transparent, four-step journey handled end-to-end by our in-house team."
          className="mx-auto"
        />
      </Reveal>

      <div className="mt-16 relative">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-6">
          {STEPS.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <Reveal key={s.n} delay={i * 0.1} className="relative text-center">
                <div className="relative z-10 mx-auto grid place-items-center h-16 w-16 rounded-full bg-white border-2 border-brand-green shadow-soft">
                  <Icon className="h-7 w-7 text-brand-green" />
                </div>
                <h3 className="mt-5 text-lg font-bold text-brand-navy">{s.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-slate-500 max-w-[240px] mx-auto">{s.desc}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
